const findItemByUrl = (urlToFind: string, itemList) => {
  for (const item of itemList) {
    if (item.url === urlToFind) {
      // Item found in the current level
      return item;
    }

    if (item.children && Array.isArray(item.children)) {
      const childResult = findItemByUrl(urlToFind, item.children);
      if (childResult) {
        // Item found in the children array
        return childResult;
      }
    }
  }

  // Item not found
  return null;
};

export default findItemByUrl;
